var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SLA",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.451,
    height: 18.118,
    viewBox: "0 0 18.451 18.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M83.14,177.995a8.575,8.575,0,1,1,8.561-8.576A8.578,8.578,0,0,1,83.14,177.995Zm0-15.736a7.16,7.16,0,1,0,7.15,7.16A7.162,7.162,0,0,0,83.14,162.259Z",
    transform: "translate(-73.957 -160.281)",
    fill: "#0073b2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9286",
    "data-name": "Path 9286",
    d: "M0,.724H1.561V1.806H0Z",
    transform: "translate(8.394 -0.724)",
    fill: "#0073b2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 1.5,
    height: 1,
    transform: "matrix(0.766, -0.643, 0.643, 0.766, 3.204, 1.973)",
    fill: "#0073b2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 1.5,
    height: 1,
    transform: "translate(0 7.75) rotate(-79.999)",
    fill: "#0073b2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 1,
    height: 1.5,
    transform: "translate(0.963 13.613) rotate(-29.977)",
    fill: "#0073b2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 1,
    height: 1.5,
    transform: "matrix(0.342, -0.94, 0.94, 0.342, 5.454, 17.606)",
    fill: "#0073b2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 1.5,
    height: 0.839,
    transform: "translate(11.659 17.179) rotate(-19.99)",
    fill: "#0073b2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 1.5,
    height: 1,
    transform: "translate(16.397 13.265) rotate(-60.008)",
    fill: "#0073b2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 1.002,
    height: 1.5,
    transform: "translate(17.205 7.474) rotate(-9.974)",
    fill: "#0073b2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 1.489,
    height: 1.5,
    transform: "matrix(0.643, -0.766, 0.766, 0.643, 13.399, 2.514)",
    fill: "#0073b2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9287",
    "data-name": "Path 9287",
    d: "M658.374,393.565a.835.835,0,0,0-.274.047l-3.326-2.271a.5.5,0,0,0-.7.136.512.512,0,0,0,.135.708l3.327,2.271a.844.844,0,1,0,.842-.891Z",
    transform: "translate(-649.265 -385.133)",
    fill: "#0073b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.8ce6e92c09abccb980c73692364a2289.svg";
export { ForwardRef as ReactComponent };